<template>
    <div class="contact-details d-flex align-items-center justify-content-center flex-column">
        <p class="mb-0 agent-name">
            {{ name }}
        </p>
        <p class="mb-0 agent-role">
            Real Estate Agent
        </p>
        <agent-contact-info
            :landing-page="landingPage"
            class="text-center"
        />
    </div>
</template>

<script>
    import './ContactDetails.scss';
    import LandingPageAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageAppResource";
    import AgentContactInfo from "../Home/AgentContactInfo/AgentContactInfo";

    export default {
        name: "ContactDetails",
        components: {AgentContactInfo},
        props: {
            landingPage: {
                type: LandingPageAppResource,
                required: true
            },
        },

        computed: {
            name() {
                return this.landingPage.displayName
                    || [this.landingPage.firstName, this.landingPage.lastName].join(' ');
            },
        }
    };
</script>
